"use client"

interface PortraitSectionProps {
  heroConfig: {
    portrait?: string
    displayName?: string
    name?: string
  } | null
  heroType?: string
  heroColor?: string
  selectedHeroType: string
  onSelectHero?: () => void
  scale: number
  isHeroSelected?: boolean
  variant?: "game" | "shop"
}

export const PortraitSection = ({
  heroConfig,
  heroType,
  heroColor,
  selectedHeroType,
  onSelectHero,
  scale,
  isHeroSelected = false,
  variant = "game",
}: PortraitSectionProps) => {
  const effectiveScale = scale > 0 ? scale : 1
  const width = 84 * effectiveScale
  const height = 84 * effectiveScale
  const left = 19 * effectiveScale
  const top = 26 * effectiveScale

  const portraitImage = heroConfig?.portrait || "/images/hero1.png"

  const sectionId = variant === "game" ? "portrait-section" : "shop-portrait-section"

  // Shop variant is non-interactive, just displays the portrait
  if (variant === "shop") {
    return (
      <div
        id={sectionId}
        className="absolute"
        style={{
          left,
          top,
          width,
          height,
        }}
      >
        <div className="relative w-full h-full">
          <img
            src={portraitImage || "/placeholder.svg"}
            alt="Hero portrait"
            width={84}
            height={84}
            className="w-full h-full"
            style={{ imageRendering: "pixelated" }}
          />
        </div>
      </div>
    )
  }

  // Game variant is interactive with selection states
  return (
    <div
      id={sectionId}
      className="absolute"
      style={{
        left,
        top,
        width,
        height,
      }}
    >
      <button
        id="hero-portrait-button"
        onClick={onSelectHero}
        className={`w-full h-full relative overflow-hidden transition-all ${
          heroType === selectedHeroType ? "brightness-125" : "hover:brightness-110"
        }`}
        style={{
          border: isHeroSelected ? `${3 * effectiveScale}px solid white` : "none",
          boxSizing: "border-box",
        }}
      >
        {portraitImage ? (
          <img
            src={portraitImage || "/placeholder.svg"}
            alt={heroConfig?.displayName || heroConfig?.name || "Hero"}
            className="absolute inset-0 w-full h-full object-cover"
            style={{ imageRendering: "pixelated" }}
          />
        ) : (
          <div
            className="w-full h-full flex items-center justify-center"
            style={{ backgroundColor: heroColor || "#666" }}
          >
            <span className="text-white text-2xl font-bold">{heroType?.charAt(0).toUpperCase() || "?"}</span>
          </div>
        )}
      </button>
    </div>
  )
}
